import { useQuery } from '@tanstack/react-query';

import { ConfigResponse } from 'reservations/account/types';
import { BENTOBOX_CONFIG_ENDPOINT } from 'reservations/base/constants/endpoints';
import { REDIRECT_BASE_404 } from 'reservations/base/constants/redirects';
import { MINUTE_IN_MILLISECONDS } from 'reservations/base/constants/time';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { type RequestError, restClient } from 'utility/restClient';

async function fetchConfig(slug: string) {
  const endpoint = buildBentoboxApiEndpoint(BENTOBOX_CONFIG_ENDPOINT, { slug });
  const response = await restClient.get(endpoint);

  try {
    return ConfigResponse.parse(response);
  } catch (err) {
    console.error('Error parsing config response:', err);
    throw err;
  }
}

export const useConfigQuery = (slug: string) => {
  const { handleNavigation } = useCustomRouter();
  return useQuery({
    queryKey: ['config', slug],
    queryFn: () => fetchConfig(slug),
    enabled: true,
    retry: false,
    refetchInterval: MINUTE_IN_MILLISECONDS * 4,
    refetchIntervalInBackground: true,
    meta: {
      onQueryError: (_: RequestError) => {
        // istanbul ignore next
        handleNavigation(REDIRECT_BASE_404);
      }
    }
  });
};
